jQuery.feature_import("js-purchase_articlelist",
  () => require("./purchasepage-articlelistcontrol.js"),
  mod => mod.feature_js_purchase_articlelist
);